$(document).ready(function () {
  function initializeVaseCarousel() {
    $('#vase-selector')
      .trigger('destroy.owl.carousel')
      .owlCarousel({
        items: 4,
        margin: 10,
        loop: false,
        nav: true,
        dots: false,
        responsive: {
          0: { items: 3 },
          600: { items: 5 },
          1000: { items: 4 },
        },
      });

    $('#vase-selector')
      .off('mouseenter.vase mouseleave.vase click.vase')
      .on('mouseenter.vase', '.vase-option', function () {
        if ($(this).find('.vase-name').text().trim() !== 'No vase') {
          showEnlargedPreview($(this));
        }
      })
      .on('mouseleave.vase', '.vase-option', function () {
        hideEnlargedPreview();
      })
      .on('click.vase', '.vase-option', function () {
        selectVase($(this));
      });
  }

  function showEnlargedPreview(vaseElement) {
    const selectedVaseImage = vaseElement.find('img').attr('src');
    const selectedVaseName = vaseElement.find('.vase-name').text();
    const selectedVasePrice = vaseElement.find('.vase-price').text();

    $('#enlarged-preview-vase-image').attr('src', selectedVaseImage);
    $('#enlarged-preview-vase-name').text(selectedVaseName);
    $('#enlarged-preview-vase-price').text(selectedVasePrice);

    $('#enlarged-preview-vase').show();
  }

  function hideEnlargedPreview() {
    $('#enlarged-preview-vase').hide();
  }

  function selectVase(vaseElement) {
    $('.vase-option').removeClass('selected');
    vaseElement.addClass('selected');
    selectedVaseId = vaseElement.data('vase-id');
  }

  const allVasesHTML = $('.vase-option')
    .map(function () {
      return $(this).prop('outerHTML');
    })
    .get();

  function updateVasesDisplay(size) {
    let filteredVases = [];
    const noVaseOption = allVasesHTML[0];

    filteredVases.push(noVaseOption);

    for (let i = 1; i < allVasesHTML.length; i++) {
      const vaseElement = $(allVasesHTML[i]);
      const vaseSize = vaseElement.data('size');
      const vaseStock = parseInt(vaseElement.data('stock'), 10);

      if (vaseStock !== 0 && (size === 'all' || vaseSize === size)) {
        filteredVases.push(allVasesHTML[i]);
      }
    }

    if (filteredVases.length === 1) {
      for (let i = 1; i < allVasesHTML.length; i++) {
        const vaseElement = $(allVasesHTML[i]);
        const vaseStock = parseInt(vaseElement.data('stock'), 10);
        if (vaseStock !== 0) {
          filteredVases.push(allVasesHTML[i]);
        }
      }
    }

    $('#vase-selector').trigger('destroy.owl.carousel');
    $('#vase-selector').html(filteredVases.join(''));
    initializeVaseCarousel();
  }

  let selectedVariantId = null;
  let selectedCardId = null;
  let selectedVaseId = null;
  let selectedGiftId = null;
  let luxuryPackagingId = $('#luxury_packaging').val();
  let luxuryPackagingSelected = false;
  let mourningRibbonId = $('#mourning_ribbon').val();
  let mourningRibbonSelected = false;
  let maxStock = Infinity;

  function selectVariant(option) {
    $('.variant-option').removeClass('selected');
    option.addClass('selected');
    selectedVariantId = option.data('variant-id');
    const limit = Number(option.attr('data-max-quantity'));
    maxStock = Number.isFinite(limit) && limit > 0 ? limit : Infinity;
    $('#quantity').val(1);
    if (Number.isFinite(maxStock)) $('#quantity').attr('max', maxStock);
    else $('#quantity').removeAttr('max');
    updateMainPrice(option.data('price'), option.data('compare-at-price'));
  }

  const firstVariant = $('.variant-option').first();
  if (firstVariant.length) selectVariant(firstVariant);
  if ($('.variant-option').length === 1) {
    $('#variant-selector, .title-form-variant').hide();
  }

  const initialSize = $('.variant-option.selected').data('size') || 'all';
  updateVasesDisplay(initialSize);

  $('#variant-selector, #card-selector, #gift-selector')
    .each(function () {
      $(this).trigger('destroy.owl.carousel');
    })
    .owlCarousel({
      items: 4,
      margin: 10,
      loop: false,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 3 },
        600: { items: 5 },
        1000: { items: 4 },
      },
    });

  function updateMainPrice(price, compareAtPrice) {
    if (!price) return;
    let priceHtml = '';
    if (compareAtPrice) {
      priceHtml += `<del class="compare-at-price">${compareAtPrice}</del> `;
    }
    priceHtml += `<span class="current-price">${price}</span>`;
    $('.text-price').html(priceHtml);
  }

  $('.variant-option')
    .off('click.variant')
    .on('click.variant', function () {
      selectVariant($(this));

      const selectedSize = $(this).data('size') || 'all';
      updateVasesDisplay(selectedSize);
    });

  $('#luxury_packaging')
    .off('change.lux')
    .on('change.lux', function () {
      luxuryPackagingSelected = $(this).is(':checked');
    });

  $('#mourning_ribbon')
    .off('change.ribbon')
    .on('change.ribbon', function () {
      mourningRibbonSelected = $(this).is(':checked');
    });

  $('.card-option')
    .off('click.cardJQ')
    .on('click.cardJQ', function () {
      selectedCardId = $(this).data('card-id');
      $('.card-option').removeClass('selected');
      $(this).addClass('selected');
    });

  $('.vase-option')
    .off('click.vaseSel')
    .on('click.vaseSel', function () {
      selectVase($(this));
    });

  $('.gift-option')
    .off('click.gift')
    .on('click.gift', function () {
      const wasSelected = $(this).hasClass('selected');
      $('.gift-option').removeClass('selected');
      selectedGiftId = wasSelected ? null : $(this).data('gift-id');
      if (!wasSelected) $(this).addClass('selected');
    });

  $('#increase-qty')
    .off('click.qtyInc')
    .on('click.qtyInc', function () {
      let currentQty = parseInt($('#quantity').val(), 10) || 1;

      if (maxStock === 0) {
        alert('This product is out of stock.');
      } else if (maxStock < 0) {
        $('#quantity').val(currentQty + 1);
      } else if (currentQty < maxStock) {
        $('#quantity').val(currentQty + 1);
      }
    });

  $('#decrease-qty')
    .off('click.qtyDec')
    .on('click.qtyDec', function () {
      let currentQty = parseInt($('#quantity').val(), 10) || 1;
      if (currentQty > 1) {
        $('#quantity').val(currentQty - 1);
      }
    });

  $('#quantity')
    .off('change.qtyInput')
    .on('change.qtyInput', function () {
      let newQty = parseInt($(this).val(), 10) || 1;

      if (maxStock === 0) {
        $(this).val(1);
        alert('This product is out of stock.');
      } else if (maxStock > 0 && newQty > maxStock) {
        $(this).val(maxStock);
        alert(`The maximum quantity available is ${maxStock}.`);
      } else if (newQty < 1) {
        $(this).val(1);
      }
    });

  const forbiddenVariantIds = ['50089288237400', '50089297838424', '50089296888152'];

  let isAdding = false;
  $('#add-to-cart').css('touch-action', 'manipulation');

  $('#add-to-cart')
    .off('click.add')
    .on('click.add', function () {
      if (isAdding) return;
      isAdding = true;
      const $btn = $(this);
      const old = $btn.text();
      $btn.prop('disabled', true).addClass('is-loading').text('Adding...');

      if (!selectedVariantId) {
        alert('Please select a variant.');
        $btn.prop('disabled', false).removeClass('is-loading').text(old);
        isAdding = false;
        return;
      }

      if (maxStock === 0) {
        alert('This variant is sold out.');
        $btn.prop('disabled', false).removeClass('is-loading').text(old);
        isAdding = false;
        return;
      }

      const textCardValue = ($('#textCard').val() || '').trim();
      const textCardError = $('#textCardError');
      const isNoCardSelected = $('.nb').is(':visible');

      if (!isNoCardSelected && !textCardValue) {
        textCardError.removeClass('d-none');
        $('#textCard').focus();
        $btn.prop('disabled', false).removeClass('is-loading').text(old);
        isAdding = false;
        return;
      } else {
        textCardError.addClass('d-none');
      }

      $('#hiddenTextCard').val(textCardValue);

      let itemsToAdd = [
        {
          id: selectedVariantId,
          quantity: $('#quantity').val(),
          properties: {
            'Text on Card': $('#hiddenTextCard').val(),
          },
        },
      ];

      if (selectedCardId) itemsToAdd.push({ id: selectedCardId, quantity: 1 });
      if (selectedVaseId) itemsToAdd.push({ id: selectedVaseId, quantity: 1 });
      if (selectedGiftId) itemsToAdd.push({ id: selectedGiftId, quantity: 1 });
      if (luxuryPackagingSelected && luxuryPackagingId) {
        itemsToAdd.push({ id: luxuryPackagingId, quantity: 1 });
      }
      if (mourningRibbonSelected && mourningRibbonId) {
        itemsToAdd.push({ id: mourningRibbonId, quantity: 1 });
      }

      itemsToAdd = itemsToAdd.filter((item) => !forbiddenVariantIds.includes(item.id.toString()));

      if (itemsToAdd.length === 0) {
        alert('No valid items to add to the cart.');
        $btn.prop('disabled', false).removeClass('is-loading').text(old);
        isAdding = false;
        return;
      }

      window.apBloemCart.add(itemsToAdd)
        .then(() => {
          window.location.href = typeof cartUrl !== 'undefined' ? cartUrl : '/cart';
        })
        .catch((error) => {
          console.error('Error adding items to cart:', error);
          alert(error.message || 'Error adding items to cart. Check your selections.');
        })
        .finally(() => {
          $btn.prop('disabled', false).removeClass('is-loading').text(old);
          isAdding = false;
        });
    });

  const cardOptions = document.querySelectorAll('.card-option');
  const nbMessage = document.querySelector('.nb');
  const inputMessage = document.querySelector('.input');
  const textarea = document.getElementById('textCard');

  if (cardOptions.length > 1) {
    const secondCard = cardOptions[1];
    secondCard.classList.add('selected');
    selectedCardId = secondCard.getAttribute('data-card-id');

    if (secondCard.getAttribute('data-card-id') !== '50089288237400') {
      nbMessage.classList.add('d-none');
      inputMessage.classList.remove('d-none');
    }
  }

  cardOptions.forEach((cardOption) => {
    cardOption.addEventListener('click', function () {
      cardOptions.forEach((el) => el.classList.remove('selected'));
      cardOption.classList.add('selected');

      selectedCardId = cardOption.getAttribute('data-card-id');

      if (selectedCardId === '50089288237400') {
        nbMessage.classList.remove('d-none');
        inputMessage.classList.add('d-none');
        textarea.value = '';
      } else {
        nbMessage.classList.add('d-none');
        inputMessage.classList.remove('d-none');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function getVideoMimeType(url) {
    const ext = url.split('.').pop().toLowerCase();
    switch (ext) {
      case 'mp4':
        return 'video/mp4';
      case 'mov':
        return 'video/quicktime';
      case 'webm':
        return 'video/webm';
      case 'm3u8':
        return 'application/x-mpegURL';
      default:
        return 'video/mp4';
    }
  }

  $('#thumbnailCarousel')
    .trigger('destroy.owl.carousel')
    .owlCarousel({
      items: 4,
      margin: 10,
      loop: false,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 3 },
        576: { items: 4 },
        1000: { items: 4 },
      },
    });

  const mainImage = document.getElementById('mainImage');
  const mainPlayIcon = document.getElementById('mainPlayIcon');
  const modalContent = document.getElementById('modalContent');
  const imageModal = document.getElementById('imageModal');
  const thumbnails = document.querySelectorAll('.thumbnail-item');

  let currentSrc = mainImage?.src || '';
  let currentType = 'image';
  let currentPoster = '';

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', function () {
      currentType = this.dataset.type;
      currentSrc = this.dataset.src;
      currentPoster = this.dataset.poster || '';
      mainImage.src = this.src;

      if (currentType === 'video' || currentType === 'youtube') {
        mainPlayIcon.classList.remove('d-none');
      } else {
        mainPlayIcon.classList.add('d-none');
      }
    });
  });

  mainImage.addEventListener('click', function () {
    if (!currentSrc) return;

    if (currentType === 'video') {
      const mimeType = getVideoMimeType(currentSrc);
      modalContent.innerHTML = `
      <video id="modalVideo" class="w-100 rounded" controls autoplay poster="${currentPoster}">
        <source src="${currentSrc}" type="${mimeType}">
        Seu navegador não suporta vídeos.
      </video>`;
    } else if (currentType === 'youtube') {
      modalContent.innerHTML = `
      <div class="ratio ratio-16x9">
        <iframe src="${currentSrc}" frameborder="0" allowfullscreen allow="autoplay; encrypted-media"></iframe>
      </div>`;
    } else {
      modalContent.innerHTML = `<img class="img-fluid rounded" src="${currentSrc}" alt="Imagem">`;
    }
  });

  imageModal.addEventListener('hidden.bs.modal', function () {
    const modalVideo = document.getElementById('modalVideo');
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.currentTime = 0;
    }
    modalContent.innerHTML = '';

    if (currentType === 'video' || currentType === 'youtube') {
      mainPlayIcon.classList.remove('d-none');
    } else {
      mainPlayIcon.classList.add('d-none');
    }
  });
});

const textarea = document.getElementById('textCard');
if (textarea) {
  textarea.addEventListener('input', function () {
    document.getElementById('hiddenTextCard').value = this.value;
  });
}

function truncateText(selectors, maxLength) {
  const elements = document.querySelectorAll(selectors);

  elements.forEach((element) => {
    const originalText = element.innerText;
    element.setAttribute('data-original', originalText);

    if (originalText.length > maxLength) {
      element.innerText = originalText.slice(0, maxLength) + '...';
    }

    element.style.display = '-webkit-box';
    element.style.webkitBoxOrient = 'vertical';
    element.style.overflow = 'hidden';
    element.style.textOverflow = 'ellipsis';
  });
}
truncateText('#variant-selector .variant-name', 9);

$(document).ready(function () {
  function showPreview(element, previewSelector) {
    const imgSrc = $(element).find('img').attr('src');
    const name =
      $(element).find('.vase-name, .card-name, .gift-name, .variant-name').data('original') ||
      $(element).find('.vase-name, .card-name, .gift-name, .variant-name').text();
    const priceHtml = $(element).find('.vase-price, .card-price, .gift-price, .variant-price').html();

    $(previewSelector + ' img').attr('src', imgSrc);
    $(
      previewSelector +
        ' .vase-name, ' +
        previewSelector +
        ' .card-name, ' +
        previewSelector +
        ' .gift-name, ' +
        previewSelector +
        ' .variant-name'
    ).text(name);

    $(
      previewSelector +
        ' .vase-price, ' +
        previewSelector +
        ' .card-price, ' +
        previewSelector +
        ' .gift-price, ' +
        previewSelector +
        ' .variant-price'
    ).html(priceHtml);

    $(previewSelector).show();
  }

  function hidePreview(previewSelector) {
    $(previewSelector).hide();
  }

  $('.card-option')
    .off('mouseenter.cardHover mouseleave.cardHover')
    .hover(
      function () {
        if ($('.card-option').index(this) !== 0) {
          showPreview(this, '#enlarged-preview-card');
        }
      },
      function () {
        hidePreview('#enlarged-preview-card');
      }
    );

  $('.gift-option')
    .off('mouseenter.giftHover mouseleave.giftHover')
    .on('mouseenter.giftHover', function () {
      showPreview(this, '#enlarged-preview-gift');
    })
    .on('mouseleave.giftHover', function () {
      hidePreview('#enlarged-preview-gift');
    });

  $('.variant-option')
    .off('mouseenter.varHover mouseleave.varHover')
    .hover(
      function () {
        showPreview(this, '#enlarged-preview-variant');
      },
      function () {
        hidePreview('#enlarged-preview-variant');
      }
    );
});
